import styled from 'styled-components';
import { devices } from '../../../styles/viewports';
import { TickboxLabelProps, TickboxInputProps, TickboxCheckmarkProps } from '../../../types/tickbox';

interface ITickboxErrorProps {
  dark: boolean;
}

export const TickboxError = styled.div<ITickboxErrorProps>`
  margin-block: 20px;
  color: var(--base-color-${({ dark }) => (dark ? 'white' : 'errorstate')});
`;

export const TickboxLabel = styled.label<TickboxLabelProps>`
  display: block;
  width: fit-content;
  position: relative;
  padding-left: 32px;
  color: var(
    --base-color-${({ dark, disabled }) => {
        if (dark) return disabled ? 'lightgrey' : 'white';
        return disabled ? 'darkgrey' : 'black';
      }}
  );
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  div {
    margin-left: -32px;
  }

  @media ${devices.mobileAndTablet} {
    &:focus {
      outline: 0;
    }
  }
`;

export const TickboxCheckmark = styled.span<TickboxCheckmarkProps>`
  position: absolute;
  top: 1px;
  left: 0;
  height: 20px;
  width: 20px;
  padding: 3px;
  box-sizing: border-box;
  border: 1px solid
    var(
      --base-color-${({ dark, disabled, error }) => {
          if (error) return 'errorstate';
          if (disabled) return 'midgrey';
          if (dark) return 'white';
          return 'black';
        }}
    );
  background-color: var(--base-color-${({ disabled }) => (disabled ? 'lightgrey' : 'white')});
  outline: ${({ error, dark }) => (dark && error ? '1px solid var(--base-color-errorstate)' : 'none')};

  svg {
    display: none;
  }

  @media ${devices.mobile} {
    top: 0;
  }
`;

export const TickboxInput = styled.input<TickboxInputProps>`
  display: none;

  &:checked ~ ${TickboxCheckmark} {
    background-color: var(
      --base-color-${({ dark, whiteBox, disabled }) => {
          if (disabled) return 'lightgrey';
          if (dark || whiteBox) return 'white';
          return 'black';
        }}
    );
    & svg {
      display: block;
      path {
        fill: var(
          --base-color-${({ dark, whiteBox, disabled }) => {
              if (disabled) return 'midgrey';
              if (dark || whiteBox) return 'black';
              return 'white';
            }}
        );
      }
    }
  }
`;
